const Environment: any = require('@/environment.json');

const env = window.location.hostname.toLowerCase();
if (env === 'localhost') {
  // Served locally (`npm run serve` / `serve-uat` / `serve-qa1`). environment.json still holds
  // its unreplaced #{...}# deploy tokens, so every value has to be supplied here instead.
  //
  // TARGET_ENV selects which deployed *backends* we talk to. It comes from VUE_APP_TARGET_ENV,
  // supplied by .env.<mode> (see .env.uat / .env.qa1), and defaults to dev so plain
  // `npm run serve` behaves exactly as it always has.
  //
  // `environment` deliberately stays 'localhost' — roughly a dozen places gate local-dev
  // affordances on it (the prefill button in form-mixin.ts, the relaxed quoteDisabled rules in
  // QuoteComparisonGrid.vue, FullStory/Intercom suppression in main.ts). The frontend really is
  // running on localhost; only the backends follow TARGET_ENV.
  const targetEnv = process.env.VUE_APP_TARGET_ENV ?? 'dev';

  Environment.environment = 'localhost';
  Environment.TARGET_ENV = targetEnv;
  Environment.API_HOST = process.env.VUE_APP_PAPI ?? `https://pl-portal-api-${targetEnv}.amwins.com`;
  Environment.UI_HOST = 'http://localhost:8080';
  Environment.CL_UI_HOST = process.env.VUE_APP_CL_UI_HOST ?? `https://digital-${targetEnv}.amwins.com`;
  Environment.AUTH_MODE = 'OIDC';
  Environment.SBIX_HOST = process.env.VUE_APP_SBIX ?? 'https://sbix-api-dev.amwins.com';
  Environment.GOOGLE_ANALYTICS_ID = 'G-P1QJJ7JM7E';
  Environment.SEASYS_PORTAL_HOST = process.env.VUE_APP_SEASYS_PORTAL_HOST ?? 'http://localhost:4200';
  Environment.AVATAR_HOST = 'https://stidentityportal.blob.core.windows.net/avatar';
  Environment.CLIENT_ID = 'D428B280-9DB7-4A80-97BE-65D14CFCA70E';
  Environment.CLIENT_SECRET = '2C63030A-2850-47F1-B3E9-E803DD8BADBF';
  Environment.USEMOCK = process.env.VUE_APP_USEMOCK === 'true';

  Environment.STS_DOMAIN = process.env.VUE_APP_STS_DOMAIN ?? 'https://id-nonprod.amwins.com';
  Environment.STS_TARGET_ENVIRONMENT = process.env.VUE_APP_STS_TARGET_ENVIRONMENT ?? targetEnv;
  // Environment.STS_DOMAIN = 'https://localhost:5003';
  // Environment.STS_TARGET_ENVIRONMENT = 'local';
  Environment.SERVICEBUS_SUBSCRIPTION_ID = '185d5142-c467-422e-bbf8-eaf8383f3183';
  Environment.SERVICEBUS_RESOURCE_GROUP = process.env.VUE_APP_SERVICEBUS_RESOURCE_GROUP ?? 'rg-orbits-dev-eastus2';
  Environment.SERVICEBUS_NAMESPACE = process.env.VUE_APP_SERVICEBUS_NAMESPACE ?? 'sb-orbits-dev-eastus2';
  Environment.CDN_HOST = process.env.VUE_APP_CDN_HOST ?? 'https://stplportaldeveastus2.blob.core.windows.net/cdn';
}

Environment.SBIX_EFILE_HOST = Environment.SBIX_HOST + '/efile';

export default Environment;

